// extracted by mini-css-extract-plugin
export var compactFilters = "_co-4";
export var detailImage = "_co-1";
export var dropdownContainer = "_co-2";
export var imageContainer = "_co-0";
export var selectedCard = "_co-3";